import React, { useState, useEffect, useRef } from "react";
import { withRouter, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
  Grid,
} from "@material-ui/core/";
import parse from "html-react-parser";
import moment from "moment";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import {
  paymentRequest,
  SaveSelectedClassDetails,
  clearErrorMessage,
  clearValidationCheck,
  clearCorequisiteValidationCheck,
  clearTimeConflictValidationCheck,
  clearEnrolledSessions,
  clearMultipleTimeConflictValidationCheck,
  clearPrerequisitesError,
} from "../../../../reduxSlices/selectClassSlice";
import {
  isObjectEmpty,
  classStatusOptionList,
} from "../../../../utils/general";
import {
  clearLoginData,
  isLoggedInUpdate,
} from "../../../../reduxSlices/loginSlice";
import Backdrop from "../../../Backdrop";
import Aux from "../../../../hoc/Auxilliary";
import MessageIndicator from "../../../SnackBar";
import config from "../../../../app/config";
import localizedStrings from "../../../../utils/localize";
import {
  getOptionList,
  getApplicantStatus,
} from "../../../../reduxSlices/applicationSlice";

const useStyles = makeStyles({
  TableControl: {
    display: "flex",
    flexDirection: "column",
  },

  formControl: {
    color: "white",
  },
  classConatiner: {
    padding: "1rem 0",
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  classFont: {
    fontSize: "1.8rem",
    fontWeight: 500,
    flex: 1,
  },
});
const styles = {
  fontSize: "1.2rem" ,    
  background: '#efd6e1',
  padding: '6px 13px'
  }

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

function Checkout(props) {
  const classes = useStyles(props);
  const dispatch = useDispatch();
  const history = useHistory();

  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });
  const [displayMessage, setDisplayMessage] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [tableMapData, setTableMapData] = useState([]);
  const [otherClassesError, setOtherClassesError] = useState([]);
  const payRef = useRef(null);
  const selectClassData = useSelector(
    (state) => state.selectClassData.selectClassData,
  );
  const dataFetchingStatus = useSelector(
    (state) => state.selectClassData.dataFetchingStatus,
  );
  const paymentResponse = useSelector(
    (state) => state.selectClassData.paymentResponse,
  );

  const errorMessage = useSelector(
    (state) => state.selectClassData.errorMessage,
  );
  const price = useSelector((state) => state.selectClassData.price);
  const errorStatusCode = useSelector(
    (state) => state.selectClassData.errorStatusCode,
  );
  const validationCheckFailed = useSelector(
    (state) => state.selectClassData.validationCheckFailed,
  );
  const corequisitevalidationCheckFailed = useSelector(
    (state) => state.selectClassData.corequisitevalidationCheckFailed,
  );
  const timeConflictvalidationCheckFailed = useSelector(
    (state) => state.selectClassData.timeConflictvalidationCheckFailed,
  );
  const enrolledSessions = useSelector(
    (state) => state.selectClassData.enrolledSessions,
  );
  const multipleTimeConflictvalidationCheckFailed = useSelector(
    (state) => state.selectClassData.multipleTimeConflictvalidationCheckFailed,
  );
  const prerequisitesError = useSelector(
    (state) => state.selectClassData.prerequisitesError,
  );

  const applicantStatus = useSelector(
    (state) => state.applicationData.applicantStatus,
  );
  const optionList = useSelector((state) => state.applicationData.optionList);
  useEffect(() => {
    dispatch(
      getApplicantStatus(window.localStorage.getItem("x-auth-contactId")),
    );
  }, [dispatch]);
  const handleClose = () => {
    let errorCopy = { ...error };
    errorCopy.showSnackbar = false;
    setError(errorCopy);
  };
  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);
  const filterCourseIds = (classA, classB) => {
    const classBInstitutionIds = new Set(
      classB.map((b) => b.ses_institutionclassid),
    );

    return classA
      .filter((a) => !classBInstitutionIds.has(a.ses_institutionclassid))
      .map((a) => a.ses_course);
  };

  useEffect(() => {
    let remainingInstitutionIds = [];
  
    if (timeConflictvalidationCheckFailed.length > 0 || multipleTimeConflictvalidationCheckFailed.length > 0) {
      const failedChecks = [...timeConflictvalidationCheckFailed, ...multipleTimeConflictvalidationCheckFailed];
      remainingInstitutionIds = filterCourseIds(selectClassData, failedChecks);
    }
  
    setOtherClassesError(remainingInstitutionIds);
  }, [selectClassData, timeConflictvalidationCheckFailed, multipleTimeConflictvalidationCheckFailed]);
  
  const handleClick = (e) => {
    e.preventDefault();
    dispatch(paymentRequest());
  };

  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    dispatch(isLoggedInUpdate(false));
    // dispatch(clearErrorStatusCode());
    // dispatch(clearErrorMessage());
    // dispatch(clearClassData());
    props.history.push("/login");
  };

  useEffect(() => {
    let entity = "ses_class";
    let attributename = "ses_classstatus";
    dispatch(getOptionList(entity, attributename));
    dispatch(clearValidationCheck());
    dispatch(clearCorequisiteValidationCheck());
    dispatch(clearTimeConflictValidationCheck());
    dispatch(clearEnrolledSessions());
    dispatch(clearMultipleTimeConflictValidationCheck());
    dispatch(clearPrerequisitesError());
  }, [dispatch]);

  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let error = {
          isError: false,
          message: `${localizedStrings.general.sessionexpired}`,
          showSnackbar: true,
        };
        setError(error);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let error = {
          isError: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setError(error);
        // setTimeout(() => {
        //   props.history.replace("/students/select-class");
        // }, 2000);
      }
    }
  }, [errorMessage, errorStatusCode]);

  const funcOptionList = (status) => {
    var value;
    if (optionList?.length != 0) {
      optionList?.map((ele) => {
        if (ele.attributevalue === status) {
          value = ele.value;
        }
      });
    }
    return value;
  };

  useEffect(() => {
    if (selectClassData.length > 0) {
      setTableMapData(selectClassData);
      setDisabled(false);
    }
  }, [selectClassData]);

  function formatCredits(credits) {
    if (credits === 0) {
      return "0,00";
    } else {
      return credits
        ?.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
        .replace(".", ",");
    }
  }

  let tableData = "";

  if (selectClassData.length > 0) {
    if (selectClassData) {
      if (Array.isArray(selectClassData)) {
        tableData =
          tableMapData.length > 0
            ? tableMapData.map((element, index) => {
                return (
                  <StyledTableRow key={index}>
                    <StyledTableCell component="th" scope="row">
                      {element.ses_termname}
                    </StyledTableCell>
                    <StyledTableCell>
                      {element.ses_institutionclassid === (undefined || null)
                        ? ""
                        : ` ${element?.ses_institutionclassid}- ${element?.ses_classname}`}
                      <br />
                      {element?.ses_roomname === (undefined || null)
                        ? ""
                        : `${element?.ses_roomname}`}
                    </StyledTableCell>
                    <StyledTableCell>
                      {element.ses_departmentname} <br />
                      {
                        localizedStrings.students.selectClasses.modalTable
                          .startDate
                      }{" "}
                      -{`${moment(element.ses_startdate).format("YYYY-MM-DD")}`}
                      <br />
                      {
                        localizedStrings.students.selectClasses.modalTable
                          .endDate
                      }{" "}
                      -{`${moment(element.ses_enddate).format("YYYY-MM-DD")}`}
                    </StyledTableCell>
                    <StyledTableCell>
                      {" "}
                      {classStatusOptionList(element.ses_classstatus)}
                    </StyledTableCell>
                    <StyledTableCell>
                      {formatCredits(element.ses_creditsavailable)}
                    </StyledTableCell>
                    <StyledTableCell>
                      {element.usb_classnote ? element.usb_classnote : ""}
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })
            : null;
      }
    }
  }

  if (paymentResponse.length > 0) {
    return parse(paymentResponse);
  }

  const handleSubmitData = (e) => {
    let pareparePayloadForSave = selectClassData.map((e) => {
      return {
        ses_classid: e.ses_classid,
        ses_courseid: e.ses_courseid,
        ses_departmentid: e.ses_departmentid,
        ses_schoolid: e.ses_schoolid,
        ses_term: e.ses_term,
        ses_studentstatus:
          e.ses_classstatus === "Available" ? 284210000 : 284210006,
        studentId: applicantStatus.ses_applicantstatus.ses_studentid,
        contactId: window.localStorage.getItem("x-auth-contactId"),
        ses_institutionclassid: e.ses_institutionclassid,
        ses_classname: e.ses_classname,
        ses_course: e.ses_course,
      };
    });
    dispatch(SaveSelectedClassDetails(pareparePayloadForSave));
    setDisabled(true);
  };

  useEffect(() => {
    if (error.message === "You have been enrolled in the class.") {
      setDisplayMessage(localizedStrings.general.registrationcompletedMessage);
      dispatch(clearErrorMessage());
      // setTimeout(() => {
      //   history.push("/students/classes");
      // }, 3000);
    } else if (
      error.message ===
      "The student cannot be enrolled because all of the prerequisites for the course have not been met."
    ) {
      setDisplayMessage(localizedStrings.general.coursenotmeterrorMessage);
    } else if (error.message === "Invalid token") {
      setDisplayMessage(localizedStrings.general.invalidToken);
    } else if (error.message === "Something Went Wrong") {
      setDisplayMessage(localizedStrings.general.somethingwentwrong);
    } else {
      setDisplayMessage(error.message);
    }
  }, [dispatch, error]);

  return (
    <Aux>
      <MessageIndicator
        open={error.showSnackbar}
        message={displayMessage}
        handleClose={handleClose}
        autoHideDuration={30000}
      />
      <Backdrop show={dataFetchingStatus} />
      <Grid container>
        <Grid container item xs={10} style={{ margin: "0 auto" }}>
          <Grid className={classes.classConatiner}>
            <Typography component="div" className={classes.classFont}>
              {localizedStrings.students.selectClasses.selectClasses}
            </Typography>
            <Typography
              component="div"
              className={classes.classFont}
              style={{ fontSize: "1.2rem" }}
            >
              {localizedStrings.students.selectClasses.checkoutDescription}
            </Typography>
            <br />
            {!isObjectEmpty(prerequisitesError) && (
              <Typography
                component="div"
                className={classes.classFont}
                style={styles}
              >
                {" "}
                {prerequisitesError.ses_institutionclassid} -{" "}
                {localizedStrings.general.coursenotmeterrorMessage}
              </Typography>
            )}
            {multipleTimeConflictvalidationCheckFailed.length > 0 && (
              <Typography
                component="div"
                className={classes.classFont}
                style={styles}
              >
                {localizedStrings.students.selectClasses.errorMessageHeader}
                <br />
                <Typography
                  component="div"
                  className={classes.classFont}
                  style={{ fontSize: "1.2rem" }}
                >
                  {multipleTimeConflictvalidationCheckFailed?.map(
                    (element, index) => (
                      <span style={{ marginTop: "10px" }}>
                        {
                          localizedStrings.students.selectClasses.table
                            .multipleTimeConflict
                        }{" "}
                        {element["ses_institutionclassid"]}{" "}
                        {localizedStrings.students.selectClasses.table.and}{" "}
                        {element["ses_institutionclassidFound"]}
                        <br />
                      </span>
                    ),
                  )}
                  {otherClassesError?.map((element, index) => (
                    <span style={{ marginTop: "10px" }}>
                      {element} :
                      {
                        localizedStrings.students.selectClasses.table
                          .notenrolled
                      }
                      <br />
                    </span>
                  ))}
                </Typography>
              </Typography>
            )}
            {timeConflictvalidationCheckFailed.length > 0 && (
              <Typography
                component="div"
                className={classes.classFont}
                style={styles}
              >
                {localizedStrings.students.selectClasses.errorMessageHeader}
                <br />
                <Typography
                  component="div"
                  className={classes.classFont}
                  style={{ fontSize: "1.2rem" }}
                >
                  {timeConflictvalidationCheckFailed?.map((element, index) => (
                    <span style={{ marginTop: "10px" }}>
                      {element["ses_institutionclassid"]}{" "}
                      {
                        localizedStrings.students.selectClasses.table
                          .warningtimeconflict
                      }
                      <br />
                    </span>
                  ))}
                  {otherClassesError?.map((element, index) => (
                    <span style={{ marginTop: "10px" }}>
                      {element} :
                      {
                        localizedStrings.students.selectClasses.table
                          .notenrolled
                      }
                      <br />
                    </span>
                  ))}
                </Typography>
              </Typography>
            )}
            {enrolledSessions.length > 0 && (
              <Typography
                component="div"
                className={classes.classFont}
                style={styles}
              >
                {localizedStrings.students.selectClasses.errorMessageHeader}
                <br />
                <Typography
                  component="div"
                  className={classes.classFont}
                  style={{ fontSize: "1.2rem" }}
                >
                  {enrolledSessions?.map((element, index) => (
                    <div key={index} style={{ marginTop: "10px" }}>
                      {element.ses_course} :{" "}
                      {element.message === "enrolled"
                        ? localizedStrings.students.selectClasses.table.enrolled
                        : localizedStrings.general.coursenotmeterrorMessage}
                      <br />
                      {element?.usb_requisitedescription}
                    </div>
                  ))}
                </Typography>
              </Typography>
            )}
            {(validationCheckFailed.length > 0 ||
              corequisitevalidationCheckFailed.length > 0) && (
              <Typography
                component="div"
                className={classes.classFont}
                style={styles}
              >
                {" "}
                {localizedStrings.students.selectClasses.errorMessageHeader}
                <br />
                {validationCheckFailed.length > 0 &&
                  validationCheckFailed?.map((element, index) => (
                    <span style={{ marginTop: "10px" }}>
                      {" "}
                      {
                        localizedStrings.students.selectClasses
                          .errorMessageContent
                      }{" "}
                      {element.ses_course} <br />
                    </span>
                  ))}
                {corequisitevalidationCheckFailed.length > 0 && (
                  <Typography
                    component="div"
                    className={classes.classFont}
                    style={styles}
                  >
                    {corequisitevalidationCheckFailed?.map((element, index) => (
                      <span style={{ marginTop: "10px" }}>
                        {
                          element[
                            "_ses_prerequisitecourse_value@OData.Community.Display.V1.FormattedValue"
                          ]
                        }{" "}
                        {
                          localizedStrings.students.selectClasses.table
                            .corequisitemsg
                        }{" "}
                        {
                          element[
                            "_ses_course_value@OData.Community.Display.V1.FormattedValue"
                          ]
                        }{" "}
                        <br />
                      </span>
                    ))}
                  </Typography>
                )}
              </Typography>
            )}
          </Grid>
          <TableContainer
            component={Paper}
            style={{ minHeight: "40vh", marginBottom: "10px" }}
          >
            <Table aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>
                    {localizedStrings.students.selectClasses.table.term}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.students.selectClasses.table.course}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.students.selectClasses.table.description}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.students.selectClasses.table.classStatus}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.students.selectClasses.table.credits}
                  </StyledTableCell>
                  <StyledTableCell>
                    {
                      localizedStrings.students.selectClasses.modalTable
                        .classNotes
                    }
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>{tableData}</TableBody>
            </Table>
          </TableContainer>
          {selectClassData.length > 0 && (
            <Typography
              component="div"
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "1rem",
                width: "100%",
              }}
            >
              <Button
                variant="outlined"
                color="primary"
                style={{ textTransform: "capitalize" }}
                startIcon={<NavigateBeforeIcon />}
                onClick={() => props.history.goBack()}
              >
                {localizedStrings.students.selectClasses.back}
              </Button>
              {applicantStatus.ses_applicantstatus !== undefined && (
                <Typography>
                  <Button
                    variant="outlined"
                    color="primary"
                    style={{ textTransform: "capitalize" }}
                    onClick={handleSubmitData}
                    disabled={disabled}
                  >
                    {localizedStrings.students.selectClasses.submit}
                  </Button>
                </Typography>
              )}
            </Typography>
          )}
        </Grid>
      </Grid>
      <div ref={payRef}></div>
    </Aux>
  );
}

export default withRouter(Checkout);
